import { combineReducers } from 'redux';
import admin from '../modules/admin-panel/store/reducers';
import survey from '../modules/survey/survey.reducer';

export default combineReducers({
	admin,
	survey,
});
